<template>
  <client-only>
    <v-flex id="share-btn" align-self-center class="text-center">
      <v-menu offset-y background-color="#fff">
        <template v-slot:activator="{ on, attrs }">
      
          <v-btn
            text
            class="pa-0 ma-0"
            v-bind="attrs"
            v-on="on"
            @click="shareArticle"
            min-width="20"
          >
            <v-icon right dark primary--color class="ma-0" color="primary">
              icon-shape-1-2
            </v-icon>
          </v-btn>
        </template>
        <SocialShare
          :url="url"
          :title="title"
          :description="description"
          :quote="quote"
        />
      </v-menu>
    </v-flex>
  </client-only>
</template>

<script>
import SocialShare from '@/components/SocialShare'

export default {
  components: {
    SocialShare
  },
  props: {
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    quote: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showShare: false
    };
  },
  methods: {
    shareArticle(e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
#share-btn i {
  font-size: 22px;
}

#share-btn.dark .v-icon {
  color: #ffffff !important;
}

#share-btn .share-menu {
  position: absolute;
  border: 1px solid $primary;
  background: #fff;
}

.social-share {
  padding: 10px 15px !important;
  text-align: center;
  font-size: 20px !important;
  line-height: 0;
  margin-left: 15px;
  margin-top: -5px;
  background: #fff !important;
  border: 1px solid #ff7100 !important;
  border-radius: 45px !important;
}

.social-share :after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
  top: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.social-share:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: rgba(255, 0, 0, 0) transparent #ff7100 transparent;
  top: -20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.social-share span {
  margin: 0 7px;
  display: inline-flex;
}

.social-share span:hover i {
  color: #3e4a54;
}

.icon:hover {
  color: #3e4a54 !important;
}

.social-share.v-tooltip__content {
  pointer-events: all;
}

@media screen and (min-width: 600px) {
  #share-btn i {
    font-size: 22px;
  }
}
</style>
